import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Link } from 'react-router-dom'

import './style.css'

class ServicesView extends Component {
  render() {
    return (
      <Grid>
        <Row className="Services">
          {this.props.services.map(service => (
            <Col lg={4} md={6} xs={12} key={service.id}>
              <Link to={`/szolgaltatasok/${service.id}`}>
                <div className="service">
                  <div className="content">
                    <div className="title">
                      {service.nev}
                      {/* <FontAwesome name="chevron-circle-right" /> */}
                    </div>
                    <div className="description">{service['rovid-leiras']}</div>
                  </div>
                  <div
                    className="image"
                    style={{ backgroundImage: `url(${service.fokep.url})` }}
                  />
                </div>
              </Link>
            </Col>
          ))}
        </Row>
      </Grid>
    )
  }
}

export default ServicesView



// WEBPACK FOOTER //
// ./src/components/Services/ServicesView.js